import { render, staticRenderFns } from "./FeedbackBtn.vue?vue&type=template&id=3517cfd1&"
import script from "./FeedbackBtn.vue?vue&type=script&lang=js&"
export * from "./FeedbackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3517cfd1')) {
      api.createRecord('3517cfd1', component.options)
    } else {
      api.reload('3517cfd1', component.options)
    }
    module.hot.accept("./FeedbackBtn.vue?vue&type=template&id=3517cfd1&", function () {
      api.rerender('3517cfd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/FeedbackBtn.vue"
export default component.exports